import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './createideabutton.cssmodule.scss';
import { Link } from 'react-router';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';


class CreateIdeaButton extends React.Component {

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        if(!message) return '';
        return intl.formatMessage({id : message}, data);
    };
    return (
      <Link to={this.props.to} className={"btn btn-default btn-brand " + this.props.className} styleName="btn-create-idea">
            <img src={this.props.icon} className="pull-left" styleName="btn-icon" style={this.props.iconStyle} />
            <h4 style={this.props.textStyle} styleName="title">{(this.props.title)}</h4>
       </Link>
    );
  }
}

CreateIdeaButton.displayName = 'CreateIdeaButton';
CreateIdeaButton.propTypes = {};
CreateIdeaButton.defaultProps = {};

export default injectIntl(cssmodules(CreateIdeaButton, styles));



// WEBPACK FOOTER //
// ./components/Shared/CreateIdeaButton.js